import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiConfig from "../axiosConfig";
export const fetchAssets = createAsyncThunk("giftWrapperManagement/fetchAssets",
	async () => {
		const response = await apiConfig.get("wrapper-management/list");
		return response;
	}
);
export const toggelDeleteGiftWrapper = createAsyncThunk("giftWrapperManagement/toggelDelete", async (wrapperId) => {
	const response = await apiConfig.delete(`wrapper-management/delete/${wrapperId}`);
	const data = await response.data;
	return data;
});


export const addNewWrapper = createAsyncThunk("giftWrapperManagement/addNewWrapper", async (rec_data) => {
	const formData = new FormData();
	if (rec_data.image != null) {
		formData.append("file", rec_data.image, rec_data.image.name);
		const response = await apiConfig.post(`wrapper-management/upload`, formData);
		const data = await response.data.data;
		rec_data.wrapperData.backgroundImageUrl = data.csImageUlr;
		rec_data.wrapperData.backgroundImageUrlGcp = data.gcpImageUrl;
	}
	if (!rec_data.isUpdate) {
		const responseWrapper = await apiConfig.post(`wrapper-management/add`, rec_data.wrapperData);
		return responseWrapper;
	} else {
		// update action
		const responseWrapper = await apiConfig.put(`wrapper-management/update/${rec_data.wrapperData.id}`, rec_data.wrapperData);
		return responseWrapper;
	}

});
const giftWrapperManagementSlice = createSlice({
	name: "giftWrapperManagement",
	initialState: {
		assets: [],
		status: null,
		error: null,
	},
	reducers: {},
	extraReducers: {
		[fetchAssets.pending]: (state) => {
			console.log("Pending")
			state.status = "loading";
		},
		[fetchAssets.fulfilled]: (state, action) => {
			const response = action.payload.data;
			if (response.status === "OK") {
				state.status = "OK";
				state.assets = action.payload.data.data;
			} else {
				state.status = "failed";
				//state.error = action.error.message;
			}
		},
		[fetchAssets.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.error.message;
		},
		[toggelDeleteGiftWrapper.fulfilled]: (state, action) => {
			const response = action.payload;

			if (response.status === "OK") {
				const itemIndex = state.assets.findIndex((item) => item.id === action.payload.data.id);
				state.assets[itemIndex] = action.payload.data;
			}
			else {
				state.status = "failed";
				state.error = action.error.message;
			}
		},
		[addNewWrapper.fulfilled]: (state, action) => {
			const response = action.payload.data;

			if (response.status === "OK") {
				const itemIndex = state.assets.findIndex((item) => item.id === action.payload.data.data.id);
				if (itemIndex ===-1) {
					state.assets = [...state.assets, action.payload.data.data];
				} else {

					state.assets[itemIndex] = action.payload.data.data;
				}
			}
			else {
				state.status = "failed";
				state.error = action.error.message;
			}
		},
	},
});
export const assetManagementActions = giftWrapperManagementSlice.actions;
export default giftWrapperManagementSlice.reducer;
